/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DeletePreviewInfo,
  DeletedUpdateInfo,
  ElementType,
  ProjectElementInfo,
  RestoredUpdateInfo,
} from './data-contracts'
import { HttpClient, RequestParams } from './http-client'

export class DeleteElementClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
 * No description
 * 
 * @tags DeleteElement
 * @summary Посмотреть, можно ли удалить элемент и что удалится вместе с ним.
Можно использовать для запугивания пользователя.
 * @request GET:/objecttree/DeleteElement/Preview/{elementId}
 * @secure
 */
  deleteElementPreviewDeleteElementTrash = (
    elementId: string,
    query?: {
      /**
       * Удалять отмеченные и зависимые элементы
       * @default true
       */
      force?: boolean
    },
    params: RequestParams = {},
  ) =>
    this.http.request<DeletePreviewInfo, any>({
      path: `/objecttree/DeleteElement/Preview/${elementId}`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags DeleteElement
   * @summary Удалить элемент в корзину
   * @request DELETE:/objecttree/DeleteElement/ToTrash/{elementId}
   * @secure
   */
  deleteElementDeleteElementToTrash = (
    elementId: string,
    query?: {
      /**
       * Удалять отмеченные и зависимые элементы
       * @default true
       */
      force?: boolean
    },
    params: RequestParams = {},
  ) =>
    this.http.request<DeletedUpdateInfo, any>({
      path: `/objecttree/DeleteElement/ToTrash/${elementId}`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags DeleteElement
   * @summary Восстановить элемент из корзины
   * @request POST:/objecttree/DeleteElement/restore/{elementId}
   * @secure
   */
  deleteElementRestoreElementFromTrash = (elementId: string, params: RequestParams = {}) =>
    this.http.request<RestoredUpdateInfo, any>({
      path: `/objecttree/DeleteElement/restore/${elementId}`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags DeleteElement
   * @summary Получить для проекта элементы, удаленные в корзину
   * @request GET:/objecttree/DeleteElement/project/{projectId}/ElementsDeletedToTrash
   * @secure
   */
  deleteElementGetElementsDeletedToTrash = (projectId: string, params: RequestParams = {}) =>
    this.http.request<ProjectElementInfo[], any>({
      path: `/objecttree/DeleteElement/project/${projectId}/ElementsDeletedToTrash`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags DeleteElement
   * @summary Получение удаленного в корзину элемента по Id сущности
   * @request GET:/objecttree/DeleteElement/project/{projectId}/deletedToTrashByEntityId/{entityId}/type/{elementType}
   * @secure
   */
  deleteElementGetElementDeletedToTrash = (
    projectId: string,
    entityId: string,
    elementType: ElementType,
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectElementInfo, any>({
      path: `/objecttree/DeleteElement/project/${projectId}/deletedToTrashByEntityId/${entityId}/type/${elementType}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags DeleteElement
   * @summary Получить для проекта элементы, удаленные в корзину по типу
   * @request GET:/objecttree/DeleteElement/project/{projectId}/elementsFromTrash/{elementType}
   * @secure
   */
  deleteElementGetElementsFromTrash = (
    projectId: string,
    elementType: ElementType,
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectElementInfo[], any>({
      path: `/objecttree/DeleteElement/project/${projectId}/elementsFromTrash/${elementType}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
